import slice from "./storeRangeFiltersSlice";

export default slice.reducer;
